document.documentElement.classList.replace('no-js','js');
const toggle=document.querySelector('.sp-menu-toggle');
const nav=document.querySelector('#sp-navigation');
if(toggle&&nav){
  const closeMenu=()=>{toggle.setAttribute('aria-expanded','false');nav.classList.remove('is-open');};
  toggle.addEventListener('click',()=>{const open=toggle.getAttribute('aria-expanded')==='true';toggle.setAttribute('aria-expanded',String(!open));nav.classList.toggle('is-open',!open);});
  nav.querySelectorAll('a').forEach(a=>a.addEventListener('click',closeMenu));
  document.addEventListener('keydown',e=>{if(e.key==='Escape'&&nav.classList.contains('is-open')){closeMenu();toggle.focus();}});
  document.addEventListener('click',e=>{if(!e.target.closest('.sp-header'))closeMenu();});
}
document.querySelectorAll('.sp-conversation-browser').forEach(browser=>{
  const cards=[...browser.querySelectorAll('.sp-conversation-card')];
  const buttons=[...browser.querySelectorAll('[data-filter]')];
  const input=browser.querySelector('input[type=search]');
  const more=browser.querySelector('.sp-show-more');
  const count=browser.querySelector('.sp-result-count');
  const empty=browser.querySelector('.sp-no-results');
  const initial=Number(browser.dataset.limit)||6;
  let category='all',visible=initial;
  const render=()=>{
    const search=(input?.value||'').trim().toLocaleLowerCase();
    const matches=cards.filter(c=>(category==='all'||c.dataset.category===category)&&c.dataset.search.toLocaleLowerCase().includes(search));
    cards.forEach(c=>{c.hidden=true;});
    matches.slice(0,visible).forEach(c=>{c.hidden=false;});
    empty.hidden=matches.length>0;
    more.hidden=visible>=matches.length;
    count.textContent=`${Math.min(visible,matches.length)} / ${matches.length} ${count.dataset.label}`;
    buttons.forEach(b=>{const active=b.dataset.filter===category;b.classList.toggle('is-active',active);b.setAttribute('aria-pressed',String(active));});
  };
  buttons.forEach(b=>b.addEventListener('click',()=>{category=b.dataset.filter;visible=initial;render();}));
  input?.addEventListener('input',()=>{visible=initial;render();});
  more?.addEventListener('click',()=>{visible+=initial;render();});
  render();
});
const dialog=document.querySelector('#sp-video-dialog');
let videoTrigger=null;
if(dialog&&typeof dialog.showModal==='function'){
  const frame=dialog.querySelector('.sp-video-frame');
  const title=dialog.querySelector('#sp-video-title');
  document.querySelectorAll('a[data-video]').forEach(link=>link.addEventListener('click',e=>{
    if(e.metaKey||e.ctrlKey||e.shiftKey||e.altKey)return;
    const id=link.dataset.video;
    if(!/^[\w-]{11}$/.test(id))return;
    e.preventDefault();videoTrigger=link;
    const iframe=document.createElement('iframe');
    iframe.src=`https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0`;
    iframe.title=link.dataset.videoTitle||link.textContent.trim();
    iframe.allow='autoplay; encrypted-media; picture-in-picture; fullscreen';
    iframe.allowFullscreen=true;
    iframe.referrerPolicy='strict-origin-when-cross-origin';
    frame.replaceChildren(iframe);title.textContent=iframe.title;
    dialog.querySelector('.sp-video-external').href=`https://www.youtube.com/watch?v=${id}`;
    dialog.showModal();document.body.style.overflow='hidden';
  }));
  dialog.querySelector('.sp-video-close').addEventListener('click',()=>dialog.close());
  dialog.addEventListener('click',e=>{if(e.target===dialog){const rect=dialog.getBoundingClientRect();if(e.clientX<rect.left||e.clientX>rect.right||e.clientY<rect.top||e.clientY>rect.bottom)dialog.close();}});
  dialog.addEventListener('close',()=>{frame.replaceChildren();document.body.style.overflow='';videoTrigger?.focus();});
}
